// extracted by mini-css-extract-plugin
export default {"main":"Landing_main__Dfdvh","container":"Landing_container__19Kqp","lines":"Landing_lines__74of2","contents":"Landing_contents__aRM31"};